import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import {
  CAJA_FLOW_TYPE_EDIT,
  CAJA_FLOW_TYPE_REFRESH,
  CAJA_FLOW_TYPE_MULTILOCATION,
} from 'src/app/constants/tealium';
import { actionUpdateCajaFlowType } from 'src/app/state/modules/tealium/cajaFlowType';
import type AppState from 'src/types/appState';
import type { FlowType } from 'src/types/jobFlow';

export const TEALIUM_FLOW_TYPE_MAP = {
  edit: CAJA_FLOW_TYPE_EDIT,
  refresh: CAJA_FLOW_TYPE_REFRESH,
  multilocation: CAJA_FLOW_TYPE_MULTILOCATION,
} as Record<Exclude<FlowType, 'create'>, string>;

// TODO: revisit data clean up and double reset
// and refactor useTealiumCreateFlowType & useFlowType
// Do not used for
export const useTealiumFlowType = (type: Exclude<FlowType, 'create'>) => {
  const { isDataCleanupComplete } = useSelector(
    (state: AppState) => ({
      isDataCleanupComplete: state.app.isDataCleanupComplete,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (isDataCleanupComplete) {
      dispatch(actionUpdateCajaFlowType(TEALIUM_FLOW_TYPE_MAP[type]));
    }
  }, [dispatch, isDataCleanupComplete, type]);
};
